<template>
  <div>
    <div class="tim_class">
      <Lefticon :leftindex="index" @leftChange="leftChange"></Lefticon>

      <TimindexOne v-if="index == 0"></TimindexOne>

      <TimindexTwo v-if="index == 1" :nowlist="nowlist" :toUserInfo="toUserInfo"></TimindexTwo>

      <TimindexThree v-if="index == 2" :FriendList="FriendList" @gohuihuaNow="checkNowlist" @close="closeTim"></TimindexThree>

      <!-- <TimindexFour v-if="index == 3" @gohuihuaNow="checkNowlist"></TimindexFour> -->

    </div>
  </div>
</template>

<script>
import Lefticon from './lefticon.vue';

import TimindexOne from './timindexOne.vue'

import TimindexTwo from './timindexTwo.vue'

import TimindexThree from './timindexThree.vue'
import TimindexFour from './timindexFour.vue'
import { getnotReadNum } from '@/api/index.js'


export default {
  components: {
    Lefticon, TimindexOne, TimindexTwo, TimindexThree,TimindexFour
  },
  props: {
    //1等位到某个人  2直接打开
    openNum: {
      type: Number,
      default: 1
    },
    chatID: {type: Number,default:0}
  },
  name: '',
  data() {
    return {
      toUserInfo: {},
      UserInfo: {},
      isshowhaoyou: false,
      userID: '',
      index: 1,
      nowlist: [],



      FriendList: [] //朋友列表 传递给组件
    }
  },
  watch: {
    openNum: {
      handler(newVal, oldVal) {
        let that = this
        //监听info对象变化
        if (newVal == 1) {
          let promise = that.tim.getUserProfile({
            userIDList: ['xj' +that.chatID] // 请注意：即使只拉取一个用户的资料，也需要用数组类型，例如：userIDList: ['user1']
          })
          promise.then(function (imResponse) {
            if(imResponse.data.length != 0)
            {
              that.checkNowlist(imResponse.data[0])
            }
          }).catch(function (imError) {
            console.warn('getUserProfile error:', imError);
          });
        } else {
          that.getlist()
        }
      },
      deep: true, //深度监听
      immediate: true
    }
  },
  mounted() {
    this.monitor()
    getnotReadNum().then(ress => {
      if (ress.code == 1) {
        this.$store.commit('SetXtxiaonum', ress.data.num)
      }
    })
  },
  methods: {
    closeTim(){
      this.$emit('close',false)
    },
    getlist() {
      let that = this
      let promise = that.tim.getConversationList();
      promise.then((imResponse) => {
        let conversationList = imResponse.data.conversationList;
        that.nowlist = conversationList
      }).catch((imError) => { console.log(imError) });
    },
    // 方法判断传递过来这个id 是否已经在会话列表里面了
    // 是就跳转 不是就增加数据跳转
    checkNowlist(info) {
      let that = this
      if (info) {
        that.index = 1
        that.nowlist = []
        let promise = that.tim.getConversationList();
        promise.then((imResponse) => {
          let conversationList = imResponse.data.conversationList ? imResponse.data.conversationList: [];
          let isExist = conversationList.findIndex(item => item.userProfile.userID === info.userID)
          //true 不存在 /判断要咨询的人是否已经有过会话了
          if (isExist == -1) {
            conversationList.unshift({ userProfile: info })
            that.toUserInfo = { userProfile: info }
          } else {
            let obj = conversationList.find(item => { return item.toAccount == info.userID })
            that.toUserInfo = obj
          }
          console.log(conversationList);

          that.nowlist = conversationList

        }).catch((imError) => { console.log(imError) });
      }

    },
    monitor() {
      let getFriendList = (event) => {
        this.getFriendList()
      }
      this.tim.on(this.TIM.EVENT.FRIEND_LIST_UPDATED, getFriendList); //好友列表

      let conversationList = (event) => {
        this.nowlist = event.data
      };
      // 监听会话列表
      this.tim.on(this.TIM.EVENT.CONVERSATION_LIST_UPDATED, conversationList)
    },
    leftChange(event) {
      this.index = event
      if (event == 0) {

      } else if (event == 1) {
        this.getConversationList()
      } else if (event == 2) {
        this.getFriendList()
      }
    },
    //获取好友信息
    getUserInfo(event) {
      this.userID = event.profile.userID
      if (event) {
        this.isshowhaoyou = true
        this.UserInfo = event
      }
    },
    //获取好友列表
    getFriendList() {
      let that = this
      let promise = this.tim.getFriendList();
      promise.then(function (imResponse) {
        that.FriendList = imResponse.data; // 好友列表
      }).catch(function (imError) {
        console.warn('getFriendList error:', imError); // 获取好友列表失败的相关信息
      })
    },
    getConversationList() {
      let promise = this.tim.getConversationList();
      promise.then((imResponse) => {
        let conversationList = imResponse.data.conversationList;
        this.nowlist = conversationList
      }).catch((imError) => { console.log(imError) });
    }
  }

}
</script>
<style lang='scss' scoped>
.kongts {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 700px;
  text-align: center;
  width: 790px;
  img {
    width: 224px;
    height: 224px;
  }

  .texts {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ADAAAA;
    line-height: 46px;
  }
}

.tim_class {
  border: 1px solid #eee;
  width: 1110px;
  height: 700px;
  display: flex;
  margin: 0 auto;
}
</style>